import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import { RadioButtonGroup } from 'redux-form-material-ui';
import { RadioButton } from 'material-ui/RadioButton';

import validate from './validate';

import MultiSelectExtended from 'components/shared/MultiSelectExtended';
import { colors } from 'helpers/ColorHelper';

const renderError = ({ meta: { touched, error } }) =>
  touched && error ? (
    <p style={{ color: colors.RED, fontSize: '11px', textAlign: 'center' }}>{error}</p>
  ) : (
    <span />
  );

class LeasingAgents extends Component {
  render() {
    const { handleSubmit, agents, add_property } = this.props;
    const showAddLeasingAgent = add_property && add_property.use_communal_showings === 'false';

    return (
      <div>
        <h3
          style={{
            textAlign: 'center',
            fontSize: '30px',
            marginBottom: '20px',
          }}
        >
          {' '}
          Leasing Agents{' '}
        </h3>
        <p style={{ textAlign: 'center', marginBottom: '15px' }}>
          Choose the agents responsible for showings at this property. If you work from a communal
          calendar (where agents share bookings across the city), just select communal showings
          below!
        </p>
        <Field
          name="hasLeasingAgent"
          component={renderError}
          style={{ display: 'block', textAlign: 'center' }}
        />
        <form onSubmit={handleSubmit}>
          <h5 style={{ textAlign: 'center', marginBottom: '15px' }}>Use Communal Showings</h5>
          <Field
            name="use_communal_showings"
            component={RadioButtonGroup}
            style={{ width: '187px', margin: 'auto' }}
          >
            <RadioButton
              value="true"
              label="Yes"
              style={{ width: '102px', display: 'inline-flex' }}
            />
            <RadioButton
              value="false"
              label="No"
              style={{ width: '70px', display: 'inline-flex', float: 'right' }}
            />
          </Field>
          <Field name="use_communal_showings" component={renderError} />

          {showAddLeasingAgent && (
            <Field
              name="leasing_agents"
              component={MultiSelectExtended}
              multiple
              hintText="Assign To"
              data={agents}
              menuStyle={{ minWidth: '250px' }}
              innerDivStyle={{ fontSize: '15px' }}
              style={{ fontSize: '15px', marginTop: '30px' }}
              fullWidth
            />
          )}
        </form>
        <div id="button" style={{ marginBottom: '75px' }} />
      </div>
    );
  }
}

LeasingAgents = connect((store) => {
  return {
    add_property: store.form.add_property.values,
  };
})(LeasingAgents);

LeasingAgents = reduxForm({
  form: 'add_property',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(LeasingAgents);

export default LeasingAgents;
